import React from 'react';
import bem from 'utils/bem';
import './index.sass';

const { block, el } = bem('teaser-photo');
const Photo = ({src = null, img = null, alt}) => {
    const optSrc = `/media/${src}`;
    return (
        <div className={block({loading: !src})}>
            { (src || img) ?
                <img className={el('img')} src={src ? optSrc : img} alt={alt}/> :
                <div className={el('placeholder')} style={{width: '500px'}}/>
            }
        </div>
    )
}

export default Photo;
